import React from 'react';

const inline = (text) => text.split(/(\*\*[^*]+\*\*)/g).map((part, i) => (
    part.startsWith('**') && part.endsWith('**') ? <strong key={i} className="text-neutral-900">{part.slice(2, -2)}</strong> : part
));

// Parse body line-by-line: "## " headings, consecutive "- " lines = bullet list, other consecutive lines = paragraph, blank line = break.
const parse = (body) => {
    const nodes = [];
    let para = [];
    let list = [];
    const flushPara = () => { if (para.length) { nodes.push({ type: 'p', text: para.join(' ') }); para = []; } };
    const flushList = () => { if (list.length) { nodes.push({ type: 'ul', items: list }); list = []; } };
    (body || '').split('\n').forEach((raw) => {
        const l = raw.trim();
        if (!l) { flushPara(); flushList(); return; }
        if (l.startsWith('## ')) { flushPara(); flushList(); nodes.push({ type: 'h2', text: l.slice(3) }); return; }
        if (l.startsWith('- ')) { flushPara(); list.push(l.slice(2)); return; }
        flushList(); para.push(l);
    });
    flushPara(); flushList();
    return nodes;
};

const GuideBody = ({ body }) => (
    <div className="space-y-5 text-base md:text-lg text-neutral-700 leading-relaxed" data-testid="guide-body">
        {parse(body).map((n, i) => {
            if (n.type === 'h2') {
                return <h2 key={i} className="pt-4 font-display font-black uppercase text-2xl md:text-3xl text-neutral-900">{n.text}</h2>;
            }
            if (n.type === 'ul') {
                return (
                    <ul key={i} className="space-y-2 pl-1">
                        {n.items.map((t, j) => (
                            <li key={j} className="flex gap-3"><span className="mt-2.5 h-1.5 w-1.5 bg-brand-primary flex-shrink-0" /><span>{inline(t)}</span></li>
                        ))}
                    </ul>
                );
            }
            return <p key={i}>{inline(n.text)}</p>;
        })}
    </div>
);

export default GuideBody;
